import UpdateShopOrderItemRequestModelBase from '../_generated/modelBases/update-shop-order-item-request-model-base';

export default class UpdateShopOrderItemRequestModel extends UpdateShopOrderItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
